module.exports = __webpack_public_path__ + "static/media/m1.6002b918.jpg";